import z from "zod/v4";

import { InputRequirementSchema } from "./nodes/input-requirement";
import { AiNodeContextSchema } from "./context-schemas";
import { ExecutionErrorSchema } from "./node-execution";
import { SessionStatusSchema } from "./session";

export const WorkflowExecutionResultSchema = z.object({
  sessionId: z.string(),
  status: SessionStatusSchema,
  nextAction: InputRequirementSchema.optional(),
  error: ExecutionErrorSchema.optional(),
  nextNodeId: z.string().optional(),
  updatedContext: AiNodeContextSchema,
});

export type WorkflowExecutionResult = z.infer<
  typeof WorkflowExecutionResultSchema
>;
